import React from "react";

// import assets
import ConstructionIcon from "../../../assets/loanPrograms/Construction_Home_Loans.png";
import FHAIcon from "../../../assets/loanPrograms/FHA_Home_Loans.png";
import VAIcon from "../../../assets/loanPrograms/VA_Home_Loans.png";
import BridgeIcon from "../../../assets/loanPrograms/Bridge_Home_Loan_Program.png";
import JumboConstructionIcon from "../../../assets/loanPrograms/Jumbo Construction Icon.png";

//Construction Loan Programs

const index = () => {
  const loanPrograms = [
    {
      imageUrl: ConstructionIcon,
      title: "One-Time Close Construction Home Loans",
      description:
        "Save money with only one appraisal and set of closing costs. Rates are locked in prior to closing, with final terms converted to permanent terms once construction is finalized.",
    },
    {
      imageUrl: ConstructionIcon,
      title: "Two-Time Close Construction Home Loans",
      description:
        "Use one mortgage to finance the lot or and to build on, and then one for the construction and long-term financing, with the potential to obtain lower rates.",
    },
    {
      imageUrl: FHAIcon,
      title: "FHA Construction Home Loans",
      description:
        "FHA Construction home loans are for those with lower down payments, higher debt-to-income ratios, or credit challenges. Allow for as little as 3.5% down.",
    },
    {
      imageUrl: VAIcon,
      title: "VA Construction Home Loans",
      description: "Get the same benefits as a VA Home Loan, including 0% down, but build your dream home!",
    },
    {
      imageUrl: BridgeIcon,
      title: "Construction Bridge Loan",
      description: "Stay in your current home during the construction of your new home.",
    },
    {
      imageUrl: JumboConstructionIcon,
      title: "Jumbo Construction Loan",
      description:
        "Build a high value custom home with financing that exceeds conventional loan limits and offers flexible options for larger projects.",
    },
  ];
  return (
    <div id="nav-construction-programs" className="mx-auto md:px-24">
      <div>
        <h2 className=" font-bold text-center pt-16 pb-10">Construction Loan Programs</h2>
      </div>

      <div className="grid lg:grid-cols-3 gap-2">
        {loanPrograms.map((loan, index) => (
          <div key={index} className="flex flex-col items-center p-4 px-24 my-12">
            <img src={loan.imageUrl} alt={loan.title} className="w-[150px] h-auto mb-6" />
            <h2 className="text-4xl font-bold mb-6 text-center">{loan.title}</h2>
            <p className="text-md text-center md:w-3/4">{loan.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default index;
